<template>
  <div class="email-leftbar card">
    <b-button variant="danger" v-b-modal.modal_addCollection>
      Create Collection
    </b-button>
    <hr />
    <h4 class="mt-2 mb-4  ">Collections</h4>
    <div
      v-for="(collection, index) in collections"
      :key="index"
      class="mail-list mb-2"
    >
      <b-button
        class="w-100"
        v-on:click="changeSelection(collection)"
        v-bind:variant="
          selectedCollection.name == collection.name ? 'success' : 'secondary'
        "
      >
        {{ collection.name }}
      </b-button>
    </div>

    <b-modal
      id="modal_addCollection"
      title="Add Collection"
      title-class="font-18"
      ok-title="Submit"
      @ok="submitAddCollection"
    >
      <div class="mt-4 mt-lg-0 mb-4">
        <div class="form-group">
          <label>Name</label>
          <b-form-input
            placeholder="Name..."
            v-model="addCollection_name"
            :class="{
              'is-invalid': addCollection_errors.error,
            }"
          ></b-form-input>
          <div v-if="addCollection_errors.error" class="invalid-feedback">
            <span>{{ addCollection_errors.message }}</span>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import Swal from 'sweetalert2';
import {
  getCompanyCollections,
  addCustomCollection,
  checkForDuplicateCollection,
} from '../helper/dbHelpers.js';
import VueToast from 'vue-toast-notification';

import 'vue-toast-notification/dist/theme-sugar.css';

Vue.use(VueToast);

export default {
  components: {},
  props: ['showSavePopup'],
  data() {
    return {
      collections: [],
      selectedCollection: { name: 'Customers' },
      addCollection_name: null,
      addCollection_errors: {
        error: false,
        message: null,
      },
    };
  },
  methods: {
    popUpHandler: async function() {
      if (this.showSavePopup) {
        await Swal.fire({
          title:
            'Do you want to save your changes? Any unsaved changes will be deleted.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Save Changes',
          cancelButtonText: 'Leave Page',
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            this.$emit('sidepanelPopupSave', true);
          } else {
            this.$emit('sidePanelSwalPopupCancel', true);
          }
        });
      }
    },
    populateCollections: function() {
      this.collections = [];
      //get the list of collections from the database and display them in the sidebar.
      getCompanyCollections()
        .then((returnedCollections) => {
          //add customers as the first collection
          this.collections.push({
            name: 'Customers',
          });

          returnedCollections.forEach((collection) => {
            this.collections.push({
              id: collection.id,
              name: collection.data().name,
            });
          });
        })
        .catch(() => {
          Swal.fire(
            'Error!',
            'An error was encountered while generating the list of collections.',
            'error'
          );
        });
    },
    changeSelection: async function(collection) {
      await this.popUpHandler();
      this.selectedCollection = collection;
      this.$emit('updateCollectionSelection', collection);
    },
    submitAddCollection: async function(bvModalEvt) {
      //check to make sure a collection for this company doesn't exist with this name
      if (await this.validateAddCollecttion()) {
        bvModalEvt.preventDefault();
      } else {
        //add the collection to the database.
        addCustomCollection(this.addCollection_name)
          .then((collection) => {
            //add the new collection to the list of collections
            this.collections.push({
              id: collection.id,
              name: this.addCollection_name,
            });
            Vue.$toast.open({
              message: 'Collection successfully added.',
              type: 'success',
              duration: 4000,
              position: 'top-right',
            });
          })
          .catch(() => {
            Swal.fire(
              'Error!',
              'An error was encountered while creating the collection.',
              'error'
            );
          });
      }
    },
    validateAddCollecttion: async function() {
      let error = false;

      if (
        this.addCollection_name == null ||
        this.addCollection_name.trim() == ''
      ) {
        error = true;
        this.addCollection_errors.error = true;
        this.addCollection_errors.message = 'Name cannot be blank';
      } else {
        //check for a collection with this name
        await checkForDuplicateCollection(this.addCollection_name)
          .then(async (querySnapshot) => {
            if (querySnapshot.size >= 1) {
              //there is a collection with this name already.
              error = true;
              Swal.fire(
                'Error!',
                'A collection with this name already exists.',
                'error'
              );
            } else {
              //there are no collections with this name. Add it to the db.
              this.addCollection_errors.error = false;
            }
          })
          .catch(() => {
            error = true;
            Swal.fire(
              'Error!',
              'An error was encountered while verifying the collection data.',
              'error'
            );
          });
        // this.addCollection_errors.error = false;
      }

      return error;
    },
  },
  mounted() {
    this.populateCollections();
  },
};
</script>
